var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-img',{staticStyle:{"opacity":"0.3"},attrs:{"src":_vm.imgSemDados,"max-width":_vm.maxWith,"max-height":_vm.maxHeigth}}),_vm._v(" "),_c('v-col',{staticClass:"d-flex justify-center align-self-center my-0 py-0",attrs:{"cols":"12"}},[_c('h4',[_vm._v(_vm._s(_vm.msg))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31a6dc6d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Comum/SemDados.vue
// module id = null
// module chunks = 